import Axios from 'axios';
import i18n from '@common/i18n.js';
import {checkUserAgent} from '@iamteacherpc/utils/checkMobileDevice.js';

export const REQUEST_CANCEL_CODE = -999998;

export function createApi() {
    const api = Axios.create({
        baseURL: process.env.VUE_APP_API_URL,
    });

    api.interceptors.request.use(checkClientOsInterceptor);
    api.interceptors.request.use(acceptLanguageInterceptor);
    api.interceptors.response.use(defaultErrorInterceptorSuccess, defaultErrorInterceptorFail);

    return api;
}

function checkClientOsInterceptor(config) {
    const userAgent = checkUserAgent();
    switch (userAgent) {
        case 'ANDROID':
            config.headers['X-CLIENT-OS'] = 'AOS';
            break;
        case 'IOS' :
            config.headers['X-CLIENT-OS'] = 'IOS';
            break;
        default:
            config.headers['X-CLIENT-OS'] = 'WEB;';
            break;
    }
    return config;
}

function acceptLanguageInterceptor(config) {
    config.headers['Accept-Language'] = i18n.locale;
    return config;
}

function defaultErrorInterceptorSuccess(response) {
    const error = getError(response);

    if (error !== true) {
        return error;
    }

    return response.data.data;
}

function defaultErrorInterceptorFail(error) {
    if (Axios.isCancel(error)) {
        return Promise.reject({
            code: REQUEST_CANCEL_CODE,
            message: 'Cancel'
        });
    }

    if (error.response) {
        return getError(error.response);
    } else {
        return getUnknownError();
    }
}

function getUnknownError() {
    return Promise.reject({
        code: -999999,
        message: i18n.t('common_unknownError')
    });
}

function getError(response) {
    if (
        !response.data.header ||
        typeof response.data.header.isSuccessful !== 'boolean' ||
        typeof response.data.header.resultCode !== 'number' ||
        !response.data.header.resultMessage
    ) {
        return getUnknownError();
    }

    if (!response.data.header.isSuccessful) {
        return Promise.reject({
            code: response.data.header.resultCode,
            message: response.data.header.resultMessage
        });
    }

    return true;
}
